import React from 'react';

import Section from '../../containers/Section';
import {
  SiJavascript,
  SiReact,
  SiExpress,
  SiNodedotjs,
  SiMongodb,
  SiMaterialui,
  SiFigma,
  SiAdobexd,
  SiMiro
} from 'react-icons/si';

import { useInView } from 'react-intersection-observer';

const Tools = () => {
  const { ref, inView } = useInView({
    threshold: 0.4,
    triggerOnce: true
  });

  return (
    <Section innerClass="pb-10 pt-24 max-w-[90%] xl:max-w-[80%] lg:pt-32" outerClass="overflow-x-hidden bg-slate-100/30" ref={ref}>
      <div className="uppercase text-xl text-center tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl">Technology We are Using</div>
      <div className={`flex flex-col items-center pt-16 transition-transform duration-1000 ${inView ? 'translate-x-0' : 'translate-x-full'} md:flex-row-reverse md:items-start md:translate-x-0 lg:pt-20`}>
        <div className="md:basis-1/2 md:pl-10">
          <div className="uppercase text-2xl text-center tracking-widest px-10 text-slate-700 font-medium md:text-left md:px-0 md:text-4xl md:leading-tight lg:text-5xl 2xl:text-8xl">We Develop Everything Using The Newest Technology</div>
          <p className="mt-4 tracking-wider text-slate-700 font-light text-md text-center md:text-left lg:text-lg 2xl:text-4xl">Subscribe and get deals from top notch companies in the world every month. Be an exclusive member of the team.</p>
        </div>
        <ul className={`flex flex-wrap w-full mt-8 md:basis-1/2 md:mt-0 transition-transform duration-1000 ${inView ? 'md:translate-x-0' : 'md:-translate-x-full'}`}>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiJavascript className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Javascript</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiReact className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">React</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiExpress className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Express</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiNodedotjs className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">NodeJS</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiMongodb className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">MongoDB</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiMaterialui className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Material Ui</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiFigma className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Figma</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiAdobexd className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Adobe XD</p>
          </li>
          <li className="p-4 w-full basis-1/3 flex flex-col justify-center items-center">
            <SiMiro className="h-12 w-12 text-slate-700 2xl:h-20 2xl:w-20" />
            <p className="text-slate-700 uppercase tracking-widest text-xs mt-2 2xl:text-xl">Miro</p>
          </li>
        </ul>
      </div>
    </Section>
  );
};

export default Tools;
